<template>
  <div class="tw-w-64">
    <SfSearchInput
      :model-value="searchValue"
      :show-result-navigation="false"
      :placeholder="I18n.t('report.search')"
      wide
      @update:model-value="handleInput"
      @clear="handleClear"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import SfSearchInput from '@app/shared/vue/components/sf-search/search-input.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

const emit =
  defineEmits<{
    search: [value: string]
  }>()

const I18n = useI18n()

const searchValue = ref('')

function handleInput(value: string | null): void {
  searchValue.value = value ?? ''
  emit('search', searchValue.value)
}

function handleClear(): void {
  searchValue.value = ''
  emit('search', '')
}
</script>
